<div class="row">
  <div class="col-md-12 mb-3">
    <div class="card p-3 shadow-sm">
      <h1 class="head1">Dashboard</h1>
      <div class="filter-wrap">
        <div class="filter-item">
          <label
            for="inputPassword6"
            class="col-form-label"
            style="width: 110px"
            >Filter By Group</label
          >
          <select
            name="group_filter"
            id="group_filter"
            class="form-select cursor-pointer"
            [(ngModel)]="selectedGroup"
            (change)="getAllDevices()"
          >
            <option value="all">All</option>
            <option *ngFor="let zone of zones" [value]="zone.id">
              {{ zone.name }}
            </option>
          </select>
        </div>
        <div class="filter-item">
          <label for="inputPassword6" class="col-form-label">Search By</label>
          <input
            type="text"
            class="form-control w-150p me-2 mb-2"
            id="consumer_search"
            [(ngModel)]="keyword"
            placeholder="Consumer ID/Name"
          />
          <button
            class="btn btn-primary-sa btn-sm mb-2 me-2 float-start"
            (click)="Search()"
          >
            Search
          </button>
          <button
            class="btn btn-primary-sa btn-sm mb-2 float-start"
            (click)="clearFilters()"
          >
            Clear
          </button>
        </div>
        <div class="filter-item float-xl-end">
          <button
            class="btn btn-primary-sa btn-sm mb-2 ms-2"
            (click)="exportDevices()"
          >
            Export
          </button>
        </div>
      </div>
      <div class="table-scroll">
        <table width="100%" class="table table-striped">
          <thead>
            <tr>
              <th class="text-nowrap">Sr No</th>
              <th (click)="sortData('consumer_id')" class="cursor-pointer">
                <span class="text-nowrap">
                  Consumer ID
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        sortColumn === 'consumer_id' && sortOrder === 'ASC',
                      'fa-sort-down':
                        sortColumn === 'consumer_id' && sortOrder === 'DESC',
                      'fa-sort': sortColumn !== 'consumer_id'
                    }"
                  ></i>
                </span>
              </th>
              <th (click)="sortData('consumer_name')" class="cursor-pointer">
                <span class="text-nowrap"
                  >Consumer Name
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        sortColumn === 'consumer_name' && sortOrder === 'ASC',
                      'fa-sort-down':
                        sortColumn === 'consumer_name' && sortOrder === 'DESC',
                      'fa-sort': sortColumn !== 'consumer_name'
                    }"
                  ></i
                ></span>
              </th>
              <th class="text-nowrap">Group</th>
              <th class="text-nowrap">Ph. No.</th>
              <th (click)="sortData('dev_eui')" class="cursor-pointer">
                <span class="text-nowrap">
                  Device EUI
                  <i
                    class="fas user-select-none"
                    [ngClass]="{
                      'fa-sort-up':
                        sortColumn === 'dev_eui' && sortOrder === 'ASC',
                      'fa-sort-down':
                        sortColumn === 'dev_eui' && sortOrder === 'DESC',
                      'fa-sort': sortColumn !== 'dev_eui'
                    }"
                  ></i
                ></span>
              </th>
              <th class="text-nowrap">Usage Type</th>
              <th class="text-nowrap text-end">Cumulative Total (Cum)</th>
              <th class="text-nowrap text-end">Forward Total (Cum)</th>
              <th class="text-nowrap text-end">Reverse Total (Cum)</th>
              <th class="text-nowrap text-end">Day Consumption (Cum)</th>
              <th class="text-nowrap">Reporting Time</th>
              <th class="text-nowrap text-end">SNR</th>
              <th class="text-nowrap text-end">RSSI</th>
              <th class="text-nowrap text-end">Max Flow Rate(Cum/hr)</th>
              <th class="text-nowrap">Reporting Interval</th>
              <th class="text-nowrap">Alert</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let device of devices
                  | paginate
                    : {
                        itemsPerPage: limit,
                        currentPage: page,
                        totalItems: totalRows
                      };
                index as i
              "
            >
              <td class="text-center">{{ (page - 1) * limit + i + 1 }}</td>
              <td>{{ device.consumer_id }}</td>
              <td>{{ device.consumer_name }}</td>
              <td>{{ device.Zone.name }}</td>
              <td>
                {{
                  device.consumer_phone
                    ? "(" + device.consumer_phone.replace(",", ") ")
                    : "-"
                }}
              </td>
              <td>
                <!--<span
                  (click)="getDeviceDetails(device.dev_eui)"
                  class="hyper-link"
                >
                  {{ device.dev_eui }}
                </span>-->
                <a
                  class="hyper-link"
                  [routerLink]="['/device', device.dev_eui, 'details']"
                  >{{ device.dev_eui }}</a
                >
              </td>
              <td>{{ device.UsageType.type }}</td>
              <td
                [ngClass]="{
                'text-end':
                 device.meter_reading !== '-',
                 'text-center':
                 device.meter_reading === '-',
              }"
              >
                {{
                  device.meter_reading != "-"
                    ? (device.meter_reading | number : "1.2-2")
                    : device.meter_reading
                }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.forward_total !== '-',
                 'text-center':
                 device.forward_total === '-',
              }"
              >
                {{
                  device.forward_total != "-"
                    ? (device.forward_total | number : "1.2-2")
                    : device.forward_total
                }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.low_flow_rate !== '-',
                 'text-center':
                 device.low_flow_rate === '-',
              }"
              >
                {{
                  device.low_flow_rate != "-"
                    ? (device.low_flow_rate | number : "1.2-2")
                    : device.low_flow_rate
                }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.daily_consumption !== '-',
                 'text-center':
                 device.daily_consumption === '-',
              }"
              >
                {{
                  device.daily_consumption != "-"
                    ? (device.daily_consumption | number : "1.2-2")
                    : device.daily_consumption
                }}
              </td>
              <td>
                {{
                  device.reporting_time != "-"
                    ? (device.reporting_time | date : "dd-MM-yyyy HH:mm:ss")
                    : "-"
                }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.snr !== '-',
                 'text-center':
                 device.snr === '-',
              }"
              >
                {{ device.snr }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.rssi !== '-',
                 'text-center':
                 device.rssi === '-',
              }"
              >
                {{ device.rssi }}
              </td>
              <td
                [ngClass]="{
                'text-end':
                 device.high_flow_rate !== '-',
                 'text-center':
                 device.high_flow_rate === '-',
              }"
              >
                {{
                  device.high_flow_rate != "-"
                    ? (device.high_flow_rate | number : "1.2-2")
                    : device.high_flow_rate
                }}
              </td>
              <td>
                {{
                  device.reporting_interval == 1440
                    ? "Daily"
                    : device.reporting_interval == 60
                    ? "Hourly"
                    : device.reporting_interval == 15
                    ? "Quarter-hourly"
                    : "-"
                }}
              </td>
              <td>{{ device.alarm_type ? "Yes" : "No" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav aria-label="Page navigation" class="pagenav-sa">
        <pagination-controls
          (pageChange)="pageChangeEvent($event)"
        ></pagination-controls>
      </nav>
    </div>
  </div>
</div>
